var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.appMode == 'employee')?_c('EmployeeProfileSetup'):(_vm.appMode == 'educator')?_c('EducatorProfileSetup'):_c('EmployerProfileSetup')
}
var staticRenderFns = []

export { render, staticRenderFns }